import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { NgClass } from '@angular/common';

@Component({
  selector: 'pm-form-field-toggle-select',
  imports: [NgClass],
  templateUrl: './pm-form-field-toggle-select.component.html',
  styleUrl: './pm-form-field-toggle-select.component.scss',
})
export class PmFormFieldToggleSelectComponent extends FormFieldComponent {
  onToggleClick(value: any) {
    if (this.formField.multiple) {
      let val: any[] = this.ctrl.value;
      if (!Array.isArray(val)) {
        val = [];
      }

      if (val.includes(value)) {
        val.splice(val.indexOf(value), 1);
      } else {
        val.push(value);
      }
      this.ctrl.patchValue(val);
    } else {
      this.ctrl.patchValue(value);
    }
  }

  isSelected(value: any) {
    if (this.formField.multiple) {
      return Array.isArray(this.ctrl.value) && this.ctrl.value.includes(value);
    }
    return value === this.ctrl.value;
  }
}
